import React from 'react';
import { CATEGORIES } from '../api';

export default function ScenarioDock({
  mode, onMode, showModeToggle,
  category, onCategory, allowedCategories,
  radiusKm, onRadius,
  capture, onCapture,
  isMobile,
}) {
  const cats = allowedCategories?.length
    ? CATEGORIES.filter(c => allowedCategories.includes(c.key))
    : CATEGORIES;

  return (
    <div className="sq-glass" style={isMobile ? styles.dockMobile : styles.dock}>
      {showModeToggle && (
        <>
          <div style={styles.modeWrap}>
            {[['quick', 'Site report'], ['feasibility', 'Centre feasibility']].map(([k, label]) => (
              <button
                key={k}
                onClick={() => onMode(k)}
                style={{ ...styles.modeBtn, ...(mode === k ? styles.modeBtnOn : {}) }}
              >
                {label}
              </button>
            ))}
          </div>
          <div style={styles.sep} />
        </>
      )}

      {mode === 'quick' && (
        <>
          <div style={styles.ctl}>
            <label style={styles.label}>Category</label>
            <select
              className="sq-select"
              value={category}
              onChange={e => onCategory(e.target.value)}
            >
              <option value="">Choose…</option>
              {cats.map(c => (
                <option key={c.key} value={c.key}>{c.label}</option>
              ))}
            </select>
          </div>
          <div style={styles.sep} />
          <div style={styles.ctl}>
            <label style={styles.label}>Catchment</label>
            <div style={styles.ctlRow}>
              <input
                className="sq-range" type="range"
                min="1" max="8" step="0.5"
                value={radiusKm}
                onChange={e => onRadius(parseFloat(e.target.value))}
              />
              <span style={styles.out}>{radiusKm.toFixed(1)} km</span>
            </div>
          </div>
          <div style={styles.sep} />
          <div style={styles.ctl}>
            <label style={styles.label}>Capture rate</label>
            <div style={styles.ctlRow}>
              <input
                className="sq-range" type="range"
                min="5" max="25" step="0.5"
                value={capture}
                onChange={e => onCapture(parseFloat(e.target.value))}
              />
              <span style={styles.out}>{capture.toFixed(1)} %</span>
            </div>
          </div>
        </>
      )}

      {mode === 'feasibility' && (
        <>
          <div style={styles.ctl}>
            <label style={styles.label}>Trade area</label>
            <div style={styles.ctlRow}>
              <input
                className="sq-range" type="range"
                min="2" max="12" step="0.5"
                value={radiusKm}
                onChange={e => onRadius(parseFloat(e.target.value))}
              />
              <span style={styles.out}>{radiusKm.toFixed(1)} km</span>
            </div>
          </div>
          <div style={styles.sep} />
          <div style={{ ...styles.ctl, maxWidth: 250 }}>
            <span style={{ fontSize: 11.5, color: 'var(--s-muted)', lineHeight: 1.5 }}>
              Analyses all 9 retail categories — GLA demand, competing centres
              and anchor fit.
            </span>
          </div>
        </>
      )}
    </div>
  );
}

const styles = {
  dock: {
    position: 'fixed',
    left: 300,
    bottom: 18,
    zIndex: 15,
    padding: '13px 18px',
    display: 'flex',
    alignItems: 'center',
    gap: 18,
  },
  dockMobile: {
    position: 'fixed',
    left: 10,
    right: 10,
    bottom: 'calc(52dvh + 10px)',
    zIndex: 15,
    padding: '10px 12px',
    display: 'flex',
    alignItems: 'center',
    gap: 12,
    overflowX: 'auto',
  },
  ctl: { display: 'flex', flexDirection: 'column', gap: 6, flexShrink: 0 },
  ctlRow: { display: 'flex', alignItems: 'center', gap: 10 },
  label: {
    font: '600 10px var(--s-sans)',
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    color: 'var(--s-faint)',
  },
  out: {
    font: '600 12px var(--s-mono)',
    color: 'var(--s-text)',
    minWidth: 50,
  },
  sep: { width: 1, alignSelf: 'stretch', background: 'var(--s-line2)', flexShrink: 0 },
  modeWrap: {
    display: 'flex',
    gap: 2,
    background: 'var(--s-w05)',
    borderRadius: 9,
    padding: 3,
    flexShrink: 0,
  },
  modeBtn: {
    appearance: 'none',
    border: 'none',
    background: 'transparent',
    color: 'var(--s-muted)',
    font: '600 12px var(--s-sans)',
    padding: '7px 12px',
    borderRadius: 7,
    cursor: 'pointer',
  },
  modeBtnOn: {
    background: 'var(--s-w12)',
    color: 'var(--s-text)',
  },
};
